export default (state = {}, action) => {
  const { type, payload } = action
  switch (type) {
    case 'FLAT_LAYERS_SET':
      return payload
    case 'LOGOUT':
      return {}
    default:
      return state
  }
}